// extracted by mini-css-extract-plugin
module.exports = {"empty":"EmptyMessage__empty___1WXKb"};